module.exports = __webpack_public_path__ + "img/slika6.730286b1.jpg";